import { z } from 'zod';
import { hidesReportBlock } from './report-rule.js';
/**
 * **Ce que la tablette demande découle du rapport** (#355, M33) : chaque bloc de saisie de la fiche
 * est relié aux sections du PDF qu'il remplit, et une section que la règle retire n'est plus
 * demandée à l'agent. Une seule règle, `ReportRule.hiddenBlocks`, pilote les deux — pas de second
 * réglage à tenir à jour.
 *
 * ⚠️ **Seuls les blocs de saisie dédiés y figurent.** Une saisie absente de la table est toujours
 * demandée : elle sert ailleurs que dans le PDF (l'export du client, la validation, la
 * transmission), ou ne se fait pas sur la fiche. Le détail section par section est en M33.
 */
export const TABLET_BLOCK_CODES = [
    'methods',
    'dwelling',
    'plot',
    'public_network',
    'connection_equipment',
    'recommendations',
];
export const tabletBlockSchema = z.enum(TABLET_BLOCK_CODES);
export const TABLET_BLOCKS = [
    // La carte « Méthodes utilisées » du Relevé.
    { code: 'methods', sections: ['methods'] },
    // La carte « Caractéristiques de l'habitation contrôlée » d'Infos.
    { code: 'dwelling', sections: ['dwelling'] },
    // La carte « Desserte de réseau EU » du Relevé, sauf le réseau public.
    { code: 'plot', sections: ['plot'] },
    // « Réseau d'assainissement public » : unitaire, les eaux de pluie vers les eaux usées ne sont
    // pas des anomalies (`stormwaterAnomalies`). Les anomalies étant verrouillées, il reste demandé.
    { code: 'public_network', sections: ['plot', 'connected_networks', 'anomalies'] },
    // La carte « Équipements de raccordement » du Relevé.
    { code: 'connection_equipment', sections: ['connection_equipment'] },
    // La carte « Travaux à réaliser » du Contrôle (#345).
    { code: 'recommendations', sections: ['recommendations'] },
];
/**
 * Les blocs de la tablette que la règle applicable rend inutiles : ceux dont **toutes** les
 * sections sont retirées du rapport.
 *
 * ⚠️ `hidesReportBlock` et non la ligne brute : une section verrouillée s'imprime toujours, donc ce
 * qui la remplit reste demandé, même sur une règle écrite en `psql` (M12). `null` : toute la fiche.
 */
export function tabletHiddenBlocksOf(rule) {
    return TABLET_BLOCKS.filter((block) => block.sections.every((section) => hidesReportBlock(rule, section))).map((block) => block.code);
}
//# sourceMappingURL=tablet-blocks.js.map